import { useState, useEffect } from 'react'
import gql from '../utils/graphql'
import { readDoctor, readDoctorLicense } from '../graphql/queries'
import { get } from 'lodash'

const useLicenses = ({ sessionId, oktaId, shouldUpdate }) => {
  const [doctorId, setDoctorId] = useState()
  const [licenses, setLicenses] = useState([])
  const [operatingStates, setOperatingStates] = useState([])
  useEffect(() => {
    const fetchLicenses = async () => {
      try {
        const doctor = get(
          await gql({
            operation: readDoctor,
            path: 'readDoctor',
            variables: {
              oktaId,
              sessionId
            }
          }),
          'body.doctor'
        )
        const doctorId = get(doctor, 'id')
        const operatingStates = get(doctor, 'doctorOperatingStateIds')
        const licenses = get(
          await gql({
            operation: readDoctorLicense,
            path: 'readDoctorLicense',
            variables: {
              doctorId,
              sessionId
            }
          }),
          'body.licenses'
        )
        setDoctorId(doctorId)
        setLicenses(licenses)
        setOperatingStates(operatingStates)
      } catch (e) {
        console.error(e)
      }
    }

    if (sessionId && oktaId) fetchLicenses()
  }, [sessionId, oktaId, shouldUpdate])

  return [doctorId, licenses, operatingStates]
}

export default useLicenses
